var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_19219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.7746L4.6967 14.4713C1.76777 11.5423 1.76777 6.7936 4.6967 3.86467C7.62563 0.935735 12.3743 0.935735 15.3033 3.86467C18.2323 6.7936 18.2323 11.5423 15.3033 14.4713L10 19.7746ZM14.1248 13.2927C16.4028 11.0147 16.4028 7.32124 14.1248 5.04318C11.8468 2.76512 8.15327 2.76512 5.87521 5.04318C3.59715 7.32124 3.59715 11.0147 5.87521 13.2927L10 17.4176L14.1248 13.2927ZM10 10.8346C9.0795 10.8346 8.33333 10.0885 8.33333 9.16797C8.33333 8.24749 9.0795 7.5013 10 7.5013C10.9205 7.5013 11.6667 8.24749 11.6667 9.16797C11.6667 10.0885 10.9205 10.8346 10 10.8346Z",
    fill: "url(#paint0_linear_184_19219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.8333C9.0782 10.8333 8.33203 10.0872 8.33203 9.16667C8.33203 8.24619 9.0782 7.5 9.9987 7.5C10.9192 7.5 11.6654 8.24619 11.6654 9.16667C11.6654 10.0872 10.9192 10.8333 9.9987 10.8333Z",
    fill: "url(#paint1_linear_184_19219)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_19219",
    x1: 2.5,
    y1: 10.7213,
    x2: 17.5,
    y2: 10.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184_19219",
    x1: 8.33203,
    y1: 9.16667,
    x2: 11.6654,
    y2: 9.16667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_19219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationColor);
export default __webpack_public_path__ + "static/media/locationColor.b79ef9640736227590a70d4791579c8a.svg";
export { ForwardRef as ReactComponent };